import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "../../contexts/ThemeContext";

const OPTIONS = [
  { id: "light", label: "Claro", icon: "bi-sun-fill" },
  { id: "dark", label: "Escuro", icon: "bi-moon-stars-fill" },
  { id: "system", label: "Sistema", icon: "bi-circle-half" },
];

/** @param {{ variant?: 'default' | 'onDark' }} props */
export default function ThemeToggle({ variant = "default" }) {
  const { preference, resolvedTheme, setPreference } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const activeIcon =
    preference === "system"
      ? "bi-circle-half"
      : resolvedTheme === "dark"
        ? "bi-moon-stars-fill"
        : "bi-sun-fill";

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        type="button"
        className={variant === "onDark" ? "portal-header-icon-btn" : "topbar-btn"}
        title="Tema da interface"
        aria-label="Tema da interface"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <i className={`bi ${activeIcon}`} />
      </button>
      {open && (
        <div
          className={`theme-menu-dropdown${variant === "onDark" ? " portal-theme-menu" : ""}`}
          role="menu"
          aria-label="Escolher tema"
        >
          <div className="theme-menu-dropdown__title">Aparência</div>
          {OPTIONS.map((opt) => (
            <button
              key={opt.id}
              type="button"
              role="menuitemradio"
              aria-checked={preference === opt.id}
              className={`theme-menu-dropdown__item${preference === opt.id ? " active" : ""}`}
              onClick={() => {
                setPreference(opt.id);
                setOpen(false);
              }}
            >
              <i className={`bi ${opt.icon}`} aria-hidden />
              {opt.label}
              {preference === opt.id && (
                <i className="bi bi-check-lg theme-menu-dropdown__check" aria-hidden />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
